// extracted by mini-css-extract-plugin
export default {"container":"PostStats_container__WjbNo"};